/* eslint-disable max-lines */
import { PictureTransformations } from 'common/components';

export type MetalRoofGalleryStructure = {
  alt: string;
  addText?: string;
  name: string;
  src: string;
  srcSmall: string;
  transformations?: PictureTransformations;
};

export const METAL_ROOF_MAIN_PAGE_SEAM_ROOFING_IMAGE_NAME_LIST = [
  {
    name: 'Гибкая черепица',
    addText: 'Коричневый',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 8017',
    subFolder: 'seam-roofing',
  },
  {
    name: 'Ондулин',
    addText: 'Зеленый',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Коричневый',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7001',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Красный',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 6034',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
    subFolder: 'seam-roofing',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7024',
  },
  {
    name: 'Ондулин',
    addText: 'Брауни',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Серый',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Каньон',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 3005',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
    subFolder: 'seam-roofing',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7024',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 3005',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Коричневый',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
    subFolder: 'seam-roofing',
  },
];

export const METAL_ROOF_MAIN_PAGE_IMAGE_NAME_LIST = [
  {
    name: 'Гибкая черепица',
    addText: 'Коричневый',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
    subFolder: 'other',
  },
  {
    name: 'Ондулин',
    addText: 'Зеленый',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Коричневый',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7001',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Красный',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 6034',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Индиана',
    subFolder: 'other',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7024',
  },
  {
    name: 'Ондулин',
    addText: 'Брауни',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Серый',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Каньон',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 3005',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7001',
    subFolder: 'other',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7024',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 3005',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Коричневый',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7001',
    subFolder: 'other',
  },
];

const METAL_ROOF_METAL_ROOFING_IMAGE_NAME_LIST = [
  {
    name: 'Металлочерепица',
    addText: 'RAL 7024',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 3005',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 8017',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7024',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7024',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7024',
  },
  {
    name: 'Металлочерепица',
    addText: 'RAL 7001',
  },
];

const METAL_ROOF_ROOFING_CORRUGATED_SHEET_IMAGE_NAME_LIST = [
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 8017',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 8017',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 6034',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 3005',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 3005',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 7024',
  },
  {
    name: 'Кровельный профнастил',
    addText: 'RAL 6034',
  },
];

const METAL_ROOF_SEAM_ROOFING_IMAGE_NAME_LIST = [
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 8017',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
  },
  {
    name: 'Фальцевая кровля',
    addText: 'RAL 7024',
  },
];

const METAL_ROOF_FLEXIBLE_SHINGLES_IMAGE_NAME_LIST = [
  {
    name: 'Гибкая черепица',
    addText: 'Коричневый',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Коричневый',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Серый',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Красный',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Красный',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Граунд',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Индиго',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Коррида',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Аризона',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Мичиган',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Индиана',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Каньон',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Континент коричневый',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Арахис',
  },
  {
    name: 'Гибкая черепица',
    addText: 'Серый',
  },
];

export const METAL_ROOF_IMAGE_LIST_MAP: Record<
  string,
  { name: string; addText: string; subFolder?: string }[]
> = {
  metallocherepica: METAL_ROOF_METAL_ROOFING_IMAGE_NAME_LIST,
  profnastil: METAL_ROOF_ROOFING_CORRUGATED_SHEET_IMAGE_NAME_LIST,
  falcevaya: METAL_ROOF_SEAM_ROOFING_IMAGE_NAME_LIST,
  'gibkaya-cherepitsa': METAL_ROOF_FLEXIBLE_SHINGLES_IMAGE_NAME_LIST,
};
